import { BehaviorSubject } from 'rxjs';

export abstract class mainData {
    abstract loading$: BehaviorSubject<boolean>;
}